const Images = {
    imagemCapaParaisopolis: require('./IMAGEM_CAPA_PARAISOPOLIS.jpg'),
    imgParaisopolis1: require('./IMG_PARAISOPOLIS-1.jpg'),
    logoFtsPreta: require('./Logo-FTS-Preta-1-1.png'),
    produtos: require('./imagem_produtos.jpeg'),
    logo1: require('./logo1.svg'),
    logo2: require('./logo2.svg'),
    logoPrefeitura: require('./logo_prefeitura.png'),
    logoSaaeFundoBranco: require('./logo_saae_fundoBranco.png'),
    logoSaneamento: require('./logo_saneamento.png'),
    logoSaneamentoParaisopolisPreto: require('./logo_saneamento_paraisopolis_preto.png'),
    saaePdf: require('./saae.pdf'),
    unifei1: require('./unifei1.jpg'),
};

export function getImage(name) {
    return Images[name];
};